import Header from "@/components/landing/Header";
import FooterSection from "@/components/landing/FooterSection";

export default function PublicPageLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#F7F5F0]">
      <Header />
      <div className="pt-16 md:pt-20">{children}</div>
      <FooterSection />
    </div>
  );
}
